export const ADDRESS_FIELDS = {
  CEP: 'cep',
  ADDRESS: 'address',
  NUMBER: 'number',
  COMPLEMENT: 'complement',
  NEIGHBORHOOD: 'neighborhood',
  STATE: 'state',
  CITY: 'city',
}

export const MENU_PROPS = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
}
